import React from 'react';
import { Link } from 'react-router-dom';

export const ArtifactNavigator = ({ realm, active }) => (
  <nav className="anav" aria-label={`Artifacts of ${realm.name}`} data-testid="artifact-nav">
    {realm.pieces.map((p) => {
      const current = p.slug === active;
      return (
        <Link
          key={p.slug}
          to={`/product/${p.slug}`}
          className={`anav-item ${current ? 'is-active' : ''}`}
          aria-current={current ? 'page' : undefined}
          aria-label={`Artifact ${p.number}: ${p.name}`}
          data-testid={`artifact-nav-${p.number}`}
        >
          <span className="anav-line" aria-hidden />
          <span className="anav-num">{p.number}</span>
        </Link>
      );
    })}
  </nav>
);
